/* PagingOsPlanDetailsFeed.js */

"use strict";
const PagingFeed = require("../../../../lib/PagingFeed");

class PagingOsPlanDetailsFeed extends PagingFeed {
    _getFeed(/*options*/) {
        return this._EntityDef.startRelatedDevicesFeed(
            this._filter,
            this._entityFields,
            this._sort,
            {skip: 0, limit: this._pageSize * 2}
        );
    }
    _planFeedReestablish() {
        return this.reestablish(this._activeOrgId, this._filter, this._entityFields, this._sort);
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadRelatedDevicesIdsForSelection(selection);
    }
}

module.exports = PagingOsPlanDetailsFeed;
